import { varColors } from '@styles/colors';
import { varFontsizes } from '@styles/fonts';
import { createGlobalStyle, css } from 'styled-components';
import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';
import { makeColorVars } from '@styles/colors/vars/var.colors-new.styles';

const ResetGlobal = css`
  :where(& *, &) {
    font-size: unset;
    transition: unset;
    font-weight: unset;
    --fontsize-md: unset;
  }
`;
const GlobalStyles = createGlobalStyle`
  :root {
    ${varColors}
    ${varFontsizes}
    ${makeColorVars()}
    /* We'll handle it at root or portal div.*/
    overflow: hidden;
    --transition-fn:  linear;
    --transition-duration:  0.1s;

  }
  :root, body {
    /* font-size: 16px; */
  }
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: var(--fontsize-md);
    transition: all 0.1s linear;
  }

  .no-transitions {
    &,*  {
      transition: unset;
    }
  }
  .reset-global {
    *:where(&  *, &) {
      font-size: unset;
      transition: unset;
      font-weight: unset;
    }
  }
  body {
    -webkit-font-smoothing: antialiased;
    background: var(--theme-background-primary);
  }

  body, input, button {
    color: #50525f;
  }

  button {
    cursor: pointer;
  }

  a {
    text-decoration: none;
  }

  .my-node-enter {
    opacity: 0;
  }
  .my-node-enter-active {
    opacity: 1;
    transition: opacity 200ms;
  }
  .my-node-exit {
    opacity: 1;
  }
  .my-node-exit-active {
    opacity: 0;
    transition: opacity 200ms;
  }

  .fade-enter {
    opacity: 0;
  }
  .fade-enter-active {
    opacity: 1;
    transition: opacity 300ms;
    position: absolute;
    top: 0;
  }
  .fade-exit {
    opacity: 1;
  }
  .fade-exit-active {
    opacity: 0;
    transition: opacity 300ms;
    position: absolute;
    top: 0;
  }
  .i__tooltip{
    --tip-text: 14px;
    --tip-opacity: 1;
    --tip-weight: 500;
    --max-w: 267px;
    max-width: var(--max-w);
    text-align: center;
    // && to override react-tooltip
    &&{
      padding: 8px 12px;
      font-weight: var(--tip-weight);
      font-size: var(--tip-text);
    }
    &&.show{
      opacity: var(--tip-opacity);
    }
  }

  .bscroll {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.15) white;
    &:hover {
      scrollbar-color: ${COLORS_FLAT.n400} white;
    }
    ::-webkit-scrollbar {
      /* padding x 2 +  width */
      /* 8*2 + 8  = 24 */
      width: 24px;
      height: 24px; /* <- same, for hor scrollbar */
    }
    ::-webkit-scrollbar-thumb {
      /* https://stackoverflow.com/a/21684424 */
      /* how much padding */
      /* = 8px */
      border: 8px solid rgba(0, 0, 0, 0);
      background-clip: padding-box;
      background-color: rgba(0, 0, 0, 0.15);
      /* will be reduced to 1/2 width anyways: https://stackoverflow.com/a/18260710 */
      border-radius: 12px;
    }

    ::-webkit-scrollbar-button {
      width: 0;
      height: 0;
      display: none;
    }
    ::-webkit-scrollbar-corner {
      background-color: transparent;
    }
  }
`;

export { GlobalStyles, ResetGlobal };
